import React from "react";

import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";

export const DeleteForeverIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\ue92b'}</MuiIcon>
    );
}
